import { useState, useRef, useEffect } from 'react';

export default function LoginScreen({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const usernameRef             = useRef(null);

  useEffect(() => {
    usernameRef.current?.focus();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password) return;

    setLoading(true);
    setError('');

    try {
      await onLogin(username.trim(), password);
    } catch (err) {
      const detail = err?.response?.data?.detail || 'Login failed. Please try again.';
      setError(detail);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-card">

        {/* Brand */}
        <div className="login-brand">
          <span className="login-brand-name">obiwan &gt;</span>
        </div>

        <h1 className="login-title">Sign in</h1>
        <p className="login-subtitle">Enter your credentials to continue.</p>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login-field">
            <label className="login-label" htmlFor="login-username">Username</label>
            <input
              ref={usernameRef}
              id="login-username"
              className="login-input"
              type="text"
              autoComplete="username"
              placeholder="your username"
              value={username}
              onChange={e => { setUsername(e.target.value); setError(''); }}
              disabled={loading}
            />
          </div>

          <div className="login-field">
            <label className="login-label" htmlFor="login-password">Password</label>
            <input
              id="login-password"
              className="login-input"
              type="password"
              autoComplete="current-password"
              placeholder="••••••••"
              value={password}
              onChange={e => { setPassword(e.target.value); setError(''); }}
              disabled={loading}
            />
          </div>

          {error && (
            <div className="login-error">{error}</div>
          )}

          <button
            type="submit"
            className="login-btn"
            disabled={loading || !username.trim() || !password}
          >
            {loading ? (
              <span className="loading-dots">
                <span /><span /><span />
              </span>
            ) : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
